export default __webpack_public_path__ + "static/media/4.fc345c6e.jpg";